import {
    BillingDtoSchema,
    BillingHistoryDtoSchema,
    BillingInfoDtoSchema,
    OrganizationOwnedPlanPricesResponseSchema,
    OrganizationEnrollmentPricingSchema,
    OrganizationPlansResponseSchema,
    SubscriptionDetailsDtoSchema,
    UpcomingInvoiceDtoSchema,
} from "@common/schemas/billing.schema";
import {
    OrganizationAdminQuantitiesExplainQuerySchema,
    OrganizationAdminQuantitiesExplainResponseSchema,
} from "@common/schemas/organization-admin.schema";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import { initContract } from "@ts-rest/core";
import { z } from "zod";

const c = initContract();

const billingOrganizationPathParams = z.object({
    organizationId: z.string().uuid(),
});

export const billingOrganizationContract = c.router(
    {
        getBillingInfo: {
            path: "/billing-info",
            method: "GET",
            pathParams: billingOrganizationPathParams,
            responses: {
                200: BillingInfoDtoSchema.nullable(),
                403: ErrorMessageSchema,
            },
        },
        getSubscriptionDetails: {
            path: "/subscription-details",
            method: "GET",
            pathParams: billingOrganizationPathParams,
            responses: {
                200: SubscriptionDetailsDtoSchema.nullable(),
                403: ErrorMessageSchema,
            },
        },
        getEnrollmentPricing: {
            path: "/enrollment-pricing",
            method: "GET",
            pathParams: billingOrganizationPathParams,
            responses: {
                200: OrganizationEnrollmentPricingSchema,
                403: ErrorMessageSchema,
            },
        },
        getUpcomingInvoice: {
            path: "/upcoming-invoice",
            method: "GET",
            pathParams: billingOrganizationPathParams,
            responses: {
                200: UpcomingInvoiceDtoSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
            },
        },
        getInvoices: {
            path: "/invoices",
            method: "GET",
            pathParams: billingOrganizationPathParams,
            responses: {
                200: BillingHistoryDtoSchema,
                403: ErrorMessageSchema,
            },
        },
        getQuantitiesExplain: {
            path: "/quantities-explain",
            method: "GET",
            pathParams: billingOrganizationPathParams,
            query: OrganizationAdminQuantitiesExplainQuerySchema,
            responses: {
                200: OrganizationAdminQuantitiesExplainResponseSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
            },
        },
        enroll: {
            path: "/enroll",
            method: "POST",
            pathParams: billingOrganizationPathParams,
            body: z.object({
                setupIntentId: z.string(),
            }),
            responses: {
                200: BillingDtoSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
            },
        },
        getPlans: {
            path: "/plans",
            method: "GET",
            pathParams: billingOrganizationPathParams,
            responses: {
                200: OrganizationPlansResponseSchema,
                403: ErrorMessageSchema,
            },
        },
        getOrganizationOwnedPlanPrices: {
            path: "/organization-owned-plan-prices",
            method: "GET",
            pathParams: billingOrganizationPathParams,
            responses: {
                200: OrganizationOwnedPlanPricesResponseSchema,
                404: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/billing-organization/:organizationId",
    },
);
